/*
* @描述: 表单预览
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-20 09:32:18
*/
<template>
    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :visible.sync="dialogVisible"
               :width="review_dialog_width"
               custom-class="review_form_dialog"
               title="">
        <div class="review_form_wrap">
            <i class="el-icon-close" @click="handleDialogClose"></i>
            <ul class="review_form_type_list">
                <li v-for="item in review_form_type_list"
                    :class="{'active':reviewFormType===item.value}"
                    class="review_form_type_item"
                    @click="handleClickReviewFormType(item)"
                    v-text="item.title">
                </li>
            </ul>
            <div v-if="reviewFormType==='pc'" :style="{'width':review_dialog_width==='680px'?'560px':'1000px'}"
                 class="pc_review_wrap">
                <div class="review_form_title" v-text="reviewFormTitle"></div>
                <div class="review_form_content">
                    <CustomFormPc key="pc"
                                  :field_list="formInfoList"
                                  :is_form_module="true"
                                  :is_preview_mode="true"
                                  @send-project-stage-fields="getStageTaskFieldList"/>
                    <div v-if="projectStageFormShow">
                        <div class="page_little_title">
                            <span class="title">阶段任务字段</span>
                        </div>
                        <CustomFormPc ref="projectStageForm"
                                      :field_list="projectStageFormFields">
                        </CustomFormPc>
                    </div>
                </div>
            </div>
            <div v-else-if="reviewFormType==='mobile'" class="mobile_review_outer_wrap">
                <div class="mobile_review_inner_wrap">
                    <div class="review_form_title">
                        <i class="el-icon-arrow-left"></i>
                        <span v-text="reviewFormTitle"></span>
                    </div>
                    <div class="review_form_content">
                        <CustomFormMobile :field_list="formInfoList"
                                          :is_form_module="true"
                                          :is_preview_mode="true"/>
                    </div>
                </div>
                <div class="mobile_handle_line"></div>
            </div>
            <div v-else class="other_review_wrap">
                <div class="review_form_title" v-text="reviewFormTitle"></div>
                <div class="review_form_content">
                    <CustomFormPc key="other"
                                  :field_list="formInfoList"
                                  :is_filter_field="true"
                                  :is_form_module="true"
                                  :is_preview_mode="true"/>
                </div>
            </div>
            <p v-if="reviewFormDesc"
               :style="{'margin-top':reviewFormType==='mobile'?'7px':'16px'}"
               class="form_desc"
               v-text="reviewFormDesc"></p>
        </div>
    </el-dialog>
</template>
<script>
    import CustomFormPc from "@/components/pComponents/CustomFormPc";
    import CustomFormMobile from "@/components/mComponents/CustomFormMobile";

    export default {
        name: "ReviewFormDialog",
        data() {
            return {
                reviewFormType: 'pc',
                reviewFormTitle: '',
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            review_dialog_width: {
                type: String,
                default: () => '680px'
            },
            //预览标题
            review_form_type_list: {
                type: Array,
                default: () => {
                    return []
                }
            },
            projectStageFormShow: false,
            projectStageFormFields: [],
            formInfoList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        components: {CustomFormPc, CustomFormMobile},
        created() {
        },
        computed: {
            reviewFormDesc() {
                return this.review_form_type_list.find(item => item.value === this.reviewFormType).form_desc
            },
        },
        mounted() {
        },
        methods: {
            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },

            //获取阶段任务字段列表
            getStageTaskFieldList(list) {
                this.projectStageFormShow = false
                this.projectStageFormFields = list
                this.$nextTick(() => {
                    this.projectStageFormShow = true
                })
            },

            //点击每个类型
            handleClickReviewFormType(item) {
                this.reviewFormType = item.value
                this.reviewFormTitle = item.form_title
            },
        },
    }
</script>
<style lang="scss" scoped>
    .review_form_wrap {
        position: relative;
        width: 100%;
        height: 736px;

        .el-icon-close {
            position: absolute;
            right: -10px;
            top: -10px;
            cursor: pointer;
            font-size: 16px;
            color: #666666;
        }

        .review_form_type_list {
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 70px;

            .review_form_type_item {
                text-align: center;
                padding: 8px 0;
                line-height: 22px;
                color: #666666;
                background-color: #EDF0F4;
                cursor: pointer;
                flex: 1;

                &:first-child {
                    border-radius: 6px 0 0 6px;
                }

                &:last-child {
                    border-radius: 0 6px 6px 0;
                }

                &.active {
                    background-color: #2990FF;
                    color: #FFFFFF;
                    font-weight: bold;
                    border-radius: 6px;
                }
            }
        }

        .pc_review_wrap {
            height: 600px;
            opacity: 1;
            border-radius: 8px;
            box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.12);
            margin: 30px auto 0;

            .review_form_title {
                padding: 16px 24px;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
                box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.08);
                font-family: 思源黑体;
            }

            .review_form_content {
                width: 100%;
                height: calc(100% - 72px);
                box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
                overflow-y: auto;
                padding: 24px;
            }
        }

        .mobile_review_outer_wrap {
            width: 391px;
            height: 640px;
            opacity: 1;
            border-radius: 30px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.12);
            margin: 30px auto 0;
            padding: 8px;
            position: relative;

            .mobile_review_inner_wrap {
                width: 100%;
                height: 100%;
                border-radius: 30px;
                border: 1px solid rgba(0, 0, 0, 0.2);

                .review_form_title {
                    padding: 6px 16px;
                    line-height: 28px;
                    font-family: 思源黑体;

                    .el-icon-arrow-left {
                        color: #666666;
                        cursor: pointer;
                        margin-right: 10px;
                        font-size: 16px;
                    }

                    span {
                        font-size: 18px;
                        font-weight: 700;
                        line-height: 32px;
                        color: #333333;
                    }
                }

                .review_form_content {
                    height: calc(100% - 68px);
                }
            }

            .mobile_handle_line {
                position: absolute;
                bottom: 18px;
                left: 50%;
                transform: translateX(-50%);
                width: 134px;
                height: 4px;
                border-radius: 10px;
                background-color: #000000;
            }
        }

        .other_review_wrap {
            width: 560px;
            height: 600px;
            opacity: 1;
            border-radius: 8px;
            box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.12);
            margin: 30px auto 0;

            .review_form_title {
                padding: 16px 24px;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
                box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.08);
                text-align: center;
                font-family: 思源黑体;
            }

            .review_form_content {
                width: 100%;
                height: calc(100% - 72px);
                overflow-y: auto;
                border-bottom: 1px solid rgba(0, 0, 0, 0.04);
            }
        }

        .form_desc {
            text-align: center;
            font-size: 12px;
            line-height: 18px;
            color: #999999;
        }
    }
</style>
<style lang="scss">
    .pc_review_wrap {
        .el-dialog__wrapper {
            .el-dialog {
                max-width: calc(100% - 20px) !important;
            }
        }
    }
</style>